export enum KeyboardCodes {
  Enter = 'Enter',
  Escape = 'Escape'
}